import { DotLottieReact } from "@lottiefiles/dotlottie-react";

export const BreathingPanda = () => {
  return (
    <DotLottieReact
      src="https://lottie.host/ebd4779a-957d-4955-9eb9-6b3e89724f29/7IhO2EoqLp.lottie"
      loop
      autoplay
    />
  );
};
